import { AxiosResponse } from "axios";
import { sponsorAxiosInstance } from "./base-service"
import { PassLocation } from "../models/IPassLocation";


export const GetPassLocations = (passpolicyId: number | undefined): Promise<AxiosResponse<PassLocation[]>> => {
    return sponsorAxiosInstance.get<PassLocation[]>(`/v1/PassLocations/Group/${passpolicyId}`);
}